import { CalendarDate } from '@internationalized/date';
import {
  UpdatePurchaseOrderInput,
  UpdatePurchaseOrderLineItemInput,
  FreightTerm,
  PaymentTerm,
} from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export type PurchaseOrderUpdateParams = {
  id: string;
  documentNumber?: string;
  startDate?: CalendarDate | null;
  endDate?: CalendarDate | null;
  accountId?: string | null;
  accountContactId?: string | null;
  accountRepresentativeId?: string | null;
  counterpartyReferenceNumber?: string | null;
  accountAddressId?: string | null;
  facilityId?: string | null;
  paymentCurrency?: string | null;
  freightTerm?: FreightTerm | null;
  paymentTerm?: PaymentTerm | null;
  notes?: string | null;
  completionNotes?: string | null;
  lineItems?: UpdatePurchaseOrderLineItemInput[];
};

export const purchaseOrderUpdateAtom = createMutationAtomFactory(
  'trade.purchaseOrderUpdate',
  (params: PurchaseOrderUpdateParams) => {
    const input: UpdatePurchaseOrderInput = {};

    if (params.documentNumber) input.documentNumber = params.documentNumber;
    if (params.startDate) input.startDate = params.startDate.toString();
    if (params.endDate) input.endDate = params.endDate.toString();
    if (params.accountId) input.accountId = params.accountId;
    if (params.accountContactId)
      input.accountContactId = params.accountContactId;
    if (params.accountRepresentativeId)
      input.accountRepresentativeId = params.accountRepresentativeId;
    if (params.counterpartyReferenceNumber)
      input.counterpartyReferenceNumber = params.counterpartyReferenceNumber;
    if (params.accountAddressId)
      input.accountAddressId = params.accountAddressId;
    if (params.facilityId) input.facilityId = params.facilityId;
    if (params.paymentCurrency) input.paymentCurrency = params.paymentCurrency;
    if (params.freightTerm) input.freightTerm = params.freightTerm;
    if (params.paymentTerm) input.paymentTerm = params.paymentTerm;
    if (params.notes !== undefined) input.notes = params.notes;
    if (params.completionNotes !== undefined)
      input.completionNotes = params.completionNotes;
    if (params.lineItems) input.lineItems = params.lineItems;

    return {
      tradePurchaseOrderUpdate: {
        __args: {
          id: params.id,
          input,
        },
        id: true,
        status: true,
        documentNumber: true,
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    };
  },
);
